if (!customElements.get('theme-localization')) {
  const OPTIONS_SECTION = 'localization-options';
  let optionsRequest = null;

  const fetchOptions = () => {
    if (!optionsRequest) {
      const url = `${window.Shopify?.routes?.root ?? '/'}?section_id=${OPTIONS_SECTION}`;
      optionsRequest = fetch(url, { credentials: 'same-origin' })
        .then(response => {
          if (!response.ok) throw new Error(`localization options: ${response.status}`);
          return response.text();
        })
        .then(html => {
          const template = document.createElement('template');
          template.innerHTML = html;
          if (!template.content.querySelector('[role="option"]')) throw new Error('localization options: empty');
          return html;
        })
        .catch(error => {
          optionsRequest = null;
          throw error;
        });
    }
    return optionsRequest;
  };

  class ThemeLocalization extends HTMLElement {
    constructor() {
      super();
      this.handleOptionClick = this.handleOptionClick.bind(this);
      this.requestOptions = this.requestOptions.bind(this);
      this.intentEvents = ['pointerover', 'pointerdown', 'focusin', 'keydown', 'click'];
    }

    connectedCallback() {
      this.abortController = new AbortController();
      const { signal } = this.abortController;
      this.addEventListener('click', this.handleOptionClick, { signal });
      this.listenForIntent();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.intentController?.abort();
    }

    listenForIntent() {
      if (!this.querySelector('[data-localization-lazy]')) return;
      this.intentController?.abort();
      this.intentController = new AbortController();
      const { signal } = this.intentController;
      this.intentEvents.forEach(type => {
        this.addEventListener(type, this.requestOptions, { capture: true, passive: true, signal });
      });
    }

    requestOptions() {
      this.intentController?.abort();
      fetchOptions()
        .then(html => this.applyOptions(html))
        .catch(() => this.listenForIntent());
    }

    applyOptions(html) {
      this.querySelectorAll('[data-localization-lazy]').forEach(panel => {
        const hadFocus = panel.contains(document.activeElement);
        const template = document.createElement('template');
        template.innerHTML = html;
        panel.replaceChildren(template.content);
        panel.removeAttribute('data-localization-lazy');
        if (hadFocus) panel.querySelector('[aria-selected="true"]')?.focus();
        const dropdown = panel.closest('theme-dropdown');
        if (dropdown?.isOpen) dropdown.updatePlacement();
      });
    }

    handleOptionClick(event) {
      const option = event.target.closest('[role="option"]');
      if (!option) return;

      option.closest('form')?.submit();
    }
  }

  customElements.define('theme-localization', ThemeLocalization);
}
